import { useEffect, useState } from 'react'

export const BOARDING_ACTION_UPDATED_EVENT = 'boarding:action-updated'

export default function useBoardingActionRefresh (employeeId) {
  const [refreshKey, setRefreshKey] = useState(0)

  useEffect(() => {
    const handleActionUpdated = (event) => {
      if (employeeId != null && String(event.detail?.employeeId) !== String(employeeId)) return

      setRefreshKey(key => key + 1)
    }
    document.addEventListener(BOARDING_ACTION_UPDATED_EVENT, handleActionUpdated)
    return () => document.removeEventListener(BOARDING_ACTION_UPDATED_EVENT, handleActionUpdated)
  }, [employeeId])

  return refreshKey
}
